class InquiryGroup {
  constructor() {
    this.contract_duration = null;
    this.notes = "";
    this.payment_term = 0;
    this.payment_method = "";
    this.settings = [];
    this.items = [];
  }
}

export default InquiryGroup;
